import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NewUserPreferences } from '@app/energy-map/models/user-preferences';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService extends ApiService {
  private baseUri = `socrates/authz/api`;

  constructor(public http: HttpClient) {
    super(http);
  }

  public getByUserPreferences(userGuid: string): Observable<string | null> {
    const uiPreferences = `uiPreferences`;
    return this.http.get<NewUserPreferences[]>(this.endpoint(this.baseUri, `users/${userGuid}?$select=${uiPreferences}`)).pipe(
      map((resp: NewUserPreferences[]): string | null => (resp.length > 0 ? resp[0].uiPreferences : null)),
      catchError(() => of(null))
    );
  }

  public patchByUserPreferences(userGuid: string, newUserPreferences: NewUserPreferences): Observable<NewUserPreferences> {
    return this.http.patch<NewUserPreferences>(this.endpoint(this.baseUri, `users/${userGuid}`), newUserPreferences);
  }
}
